import type Coupon from '@/types/Coupon'
import type DataResponse from '@/types/DataResponse'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type { AxiosResponse } from 'axios'
import { http } from '../plugins/http'
import type User from '@/types/User'

export default class CouponService {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Coupon>>> {
    return await http.get<PaginatedResponse<Coupon>>(`/api/v1/office/coupons?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<Coupon>>(`/api/v1/office/coupons/${id}`)
  }

  async store(model: Coupon, users: { assigned: string[], unassigned: string[] }) {
    return await http.post<DataResponse<Coupon>>(`/api/v1/office/coupons`, { coupon: model, users })
  }

  async update(id: string, model: Coupon, users: { assigned: string[], unassigned: string[] }) {
    return await http.put<DataResponse<Coupon>>(`/api/v1/office/coupons/${id}`, { coupon: model, users })
  }

  async destroy(model: Coupon) {
    return await http.delete(`/api/v1/office/coupons/${model.id}`, model)
  }

  async users(couponId: number, page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<User>>> {
    const _filters = filters ? `${filters}&` : ''
    return await http.get<PaginatedResponse<User>>(`/api/v1/office/coupons/${couponId}/users?${_filters}page=${page}&per_page=${per_page}`)
  }

  async searchUsers(users: string[], page: number, per_page: number | undefined = 5): Promise<AxiosResponse<PaginatedResponse<User>>> {
    return await http.post<PaginatedResponse<User>>(`/api/v1/office/coupons/users?page=${page}&per_page=${per_page}`, { users })
  }
}
